const ClearLocalStorage = () => {
  window.localStorage.clear();
};

export default ClearLocalStorage;
